<template>
    <b-form @submit="onSubmit" autocomplete="off">
        <!-- Page title -->
        <b-row>
            <b-col md="12">
                <h3 class="text-themecolor">{{$t('klantrelaties.klantrelatie')}} <span v-if="command.id">{{$t('klantrelaties.bewerker')}}</span><span v-else>{{$t('klantrelaties.aanmaker')}}</span></h3>
            </b-col>
        </b-row>
        <!-- Page title -->

        <!-- Form content -->
        <b-row>
            <b-col md="12">
                <div class="card">
                    <div class="card-body">
                        <b-form-group label-cols :label="$t('datatables.relatienr')">
                            <b-form-input v-model="command.tag" type="text" :placeholder="$t('datatables.relatienr')" />
                            <validation element="tag"/>
                        </b-form-group>
                        <b-form-group label-cols :label="$t('datatables.naam')">
                            <b-form-input v-model="command.name" type="text" :placeholder="$t('datatables.naam')" />
                            <validation element="name" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('datatables.straat')">
                            <b-form-input v-model="command.street" type="text" :placeholder="$t('datatables.straat')" />
                            <validation element="address_street" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('datatables.postcode')">
                            <b-form-input v-model="command.zipCode" type="text" :placeholder="$t('datatables.postcode')" autocomplete="on" />
                            <validation element="address_zip_code" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('klantrelaties.postbus')">
                            <b-form-input v-model="command.postbox" type="text" :placeholder="$t('klantrelaties.postbus')" />
                            <validation element="address_post_box" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('klantrelaties.plaats')">
                            <b-form-input v-model="command.city" type="text" :placeholder="$t('klantrelaties.plaats')" />
                            <validation element="address_city" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('datatables.emailadres')">
                            <b-form-input v-model="command.emailAddress" type="text" :placeholder="$t('datatables.emailadres')" />
                            <validation element="email_address_address" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('datatables.telefoonnummer')">
                            <b-form-input v-model="command.phoneNumber" type="text" :placeholder="$t('datatables.telefoonnummer')" />
                            <validation element="phone_number_number" />
                        </b-form-group>
                        <b-form-group label-cols :label="$t('klantrelaties.websiteurl')">
                            <b-form-input v-model="command.websiteUrl" type="text" :placeholder="$t('klantrelaties.websiteurl')" />
                            <validation element="website_url" />
                        </b-form-group>
                    </div>
                </div>
            </b-col>
        </b-row>
        <!-- Form content -->

        <!-- Submit controls -->
        <b-row>
            <b-col md="12">
                <b-button @click="goTo('index')" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
            </b-col>
        </b-row>
        <!-- Submit controls -->
    </b-form>
</template>
<script>
//Import store
import { mapActions, mapGetters } from 'vuex'

//Import command
import Command from './command'

export default {
    name: 'customer-relations-form',
    data() {
        return {
            command: new Command(),
        }
    },
    computed: {
        ...mapGetters('core',['customerRelation']),
    },
    methods: {
        ...mapActions('core',['create','update']),
        onSubmit(event) {
            event.preventDefault();
            var vm = this;
            var payload = {
                resource: 'customer-relations',
                params: vm.command
            };
            if(vm.command.id) {
                vm.update(payload)
                .then(()=> {
                    vm.goTo('detail');
                });
            }
            else {
                vm.create(payload)
                .then(() => {
                    vm.goTo('index');
                });
            }
        },
        goTo(name) {
            var vm = this;
            vm.$router.push({ name: `customer-relations:${name}` });
        }
    },
    created() {
        var vm = this;
        if(vm.$route.name.split(':')[1] == 'update') {
            const item = vm.customerRelation;

            if(!item.id) {
                vm.goTo('detail');
            }
            else {
                vm.command = new Command(item);
            }
        }
    }
}
</script>
